const OPTIMAL_LENGTH = 300;

export default (text: string) => {
  const stringWithoutTags = text.replace(/<[^>]+>/gm, '');
  return stringWithoutTags.length > OPTIMAL_LENGTH ? stringWithoutTags.slice(0, OPTIMAL_LENGTH) : stringWithoutTags;
};



// WEBPACK FOOTER //
// ./src/utils/getMetaDescription.ts